import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'atoms/Button/Button';
import LifeBuoySvg from 'images/v5/icons/life-buoy-02.svg';
import styles from './PageGuideCard.module.scss';
const LEAVE_TRANSITION_MS = 220;
function PageGuideCard({ children, buttons }) {
    const { t } = useTranslation('pageGuides');
    const [isActive, setIsActive] = useState(false);
    useEffect(() => {
        const timeoutId = setTimeout(() => setIsActive(true), 20);
        return () => clearTimeout(timeoutId);
    }, []);
    const dismissAnimated = (callback) => () => {
        setIsActive(false);
        setTimeout(callback, LEAVE_TRANSITION_MS);
    };
    return (React.createElement("div", { className: classNames(styles.wrap, { [styles.isActive]: isActive }) },
        React.createElement("div", { className: styles.body },
            React.createElement("div", { className: styles.badge },
                React.createElement(LifeBuoySvg, null),
                React.createElement("span", null, t('BADGE_LABEL'))),
            children),
        React.createElement("div", { className: styles.footer }, buttons.map(({ label, onClick, color }) => (React.createElement(Button, { key: label, color: color, onClick: dismissAnimated(onClick) }, label))))));
}
export default PageGuideCard;
